import React from 'react';
import graphql from "babel-plugin-relay/macro";
import {useMutation} from "react-relay";
import {useForm} from "react-hook-form";
import FormModal from "../common/modals/FormModal";
import {toast} from "react-toastify";
import * as yup from "yup";
import HorizontalFormInput from "../common/horizontal-form-inputs/HorizontalFormInput";
import {yupResolver} from "@hookform/resolvers/yup";

const NewNoteModal = ({showModal, onClose, parentId}) => {
    const mutation = graphql`
    mutation NewNoteModalMutation($parentId: ID!, $content: String!) {
        createNote(input: {parentId: $parentId, content: $content}) {
            note {
                id
                parent {
                    ... on Organization {
                        notes {
                            ...Notes
                        }
                    }
                    ... on LegalContract {
                        notes {
                            ...Notes
                        }
                    }
                    ... on Network {
                        notes {
                            ...Notes
                        }
                    }
                    ... on NetworkOwner {
                        notes {
                            ...Notes
                        }
                    }
                }}}}`
    const [commitMutation, isInFlight] = useMutation(mutation);
    const defaultValues = {
        parentId: parentId
    }
    const schema = yup.object({
        content: yup.string().required("Content is required").max(900, "Content must be 900 or less characters")
    })
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)})
    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (returned) => {
                if(returned.createNote) {
                    toast.success("New Note created");
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"New Note"}
                   isInFlight={isInFlight}
                   methods={methods}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
                   
        >
            <HorizontalFormInput controlId={"content"} 
                                 label={"Content"} 
                                 as={"textarea"}
                                 validation={{required: "Content for a note is required"}} />
        </FormModal>
    )
}
export default NewNoteModal